export default {"src":"/_next/static/media/mana5.41d87b2f.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};